module.exports = __webpack_public_path__ + "assets/img/Logitech-G-2-Social-Static-Ad-w540.c0ab7e83.webp";